// Block limits per section
export const BLOCK_LIMITS = {
  MIN: 1,
  MAX: 4,
} as const;
